import { render, staticRenderFns } from "./AttestatoFinaleAlternanzaReview.vue?vue&type=template&id=7a9ab6d0&scoped=true&"
import script from "./AttestatoFinaleAlternanzaReview.vue?vue&type=script&lang=ts&"
export * from "./AttestatoFinaleAlternanzaReview.vue?vue&type=script&lang=ts&"
import style0 from "./AttestatoFinaleAlternanzaReview.vue?vue&type=style&index=0&id=7a9ab6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9ab6d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
